import { Outlet, Link } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-felt text-white">
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-white/10 py-4 px-6 text-sm text-white/60 flex justify-between">
        <div>Setback</div>
        <div className="space-x-4">
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
        </div>
      </footer>
    </div>
  );
}
